module.exports = __webpack_public_path__ + "static/media/unidade-icon-atual.0254ee28.svg";